module.exports = __webpack_public_path__ + "img/Ramaswamy.13e29246.jpg";